import apiClient from '@/services/api_client';
import type { OrganizationPrompt } from '@/types';

export async function getOrganizationPrompt(
    tenantId: string
): Promise<OrganizationPrompt | null> {
    const response = await apiClient.get(
        `/organization_prompts?tenant_id=${encodeURIComponent(tenantId)}`
    );
    return await response.json();
}

export async function createOrganizationPrompt(
    tenantId: string,
    content: string
): Promise<OrganizationPrompt> {
    return await apiClient.post(
        `/organization_prompts?tenant_id=${encodeURIComponent(tenantId)}`,
        { content }
    );
}

export async function updateOrganizationPrompt(
    tenantId: string,
    content: string
): Promise<OrganizationPrompt> {
    return await apiClient.patch(
        `/organization_prompts?tenant_id=${encodeURIComponent(tenantId)}`,
        { content }
    );
}
